import React, {useState, useEffect, useContext, useCallback} from 'react';
import {Button} from '@material-ui/core';
import {useTranslation} from 'react-i18next';
import moment from 'moment';
import Context from 'utils/Context';
import {axiosInstance} from 'utils/auth.service';

import WRRenting from './WRRenting';
import CuultRenting from './CuultRenting';

const VODRentingButton = ({vod, cinemaId}) => {
  const [rental, setRental] = useState(null);
  const {ed, appState} = useContext(Context);
  const {t} = useTranslation();

  const isLogged = appState.user?.email || null;

  const openLoginModale = () => {
    ed.trigger('loginRegisterOpen');
  };

  const fetchRental = useCallback(() => {
    const now = moment()
      .tz(appState.conf.TIMEZONE)
      .format('YYYY-MM-DDTHH:mm:ss');
    axiosInstance.get(`/users/rentals?film.id=${vod.film?.id}&start[before]=${now}&end[after]=${now}`).then(res => {
      if (res.data) {
        setRental(res.data[0]);
      }
    });
  }, [vod.film.id, appState.conf.TIMEZONE]);

  const handleRentSuccess = useCallback(
    data => {
      if (data && data.id && data.payment_profile?.paid) {
        setRental(data);
        return;
      }
      fetchRental();
    },
    [fetchRental],
  );

  useEffect(() => {
    if (!isLogged) return;

    fetchRental();

    return () => {
      setRental(null);
    };
  }, [isLogged, fetchRental]);

  if (!isLogged)
    return (
      <div className="FilmSchedule-container">
        <Button onClick={openLoginModale} className="rent-button">
          {t('louer-en-vod')}
        </Button>
      </div>
    );

  switch (vod.video_provider) {
    case 'cuult':
      return <CuultRenting vod={vod} rental={rental} cinemaId={cinemaId} onSuccess={handleRentSuccess} />;
    case 'white_rabbit':
      return <WRRenting vod={vod} cinemaId={cinemaId} rental={rental} />;
    default:
      return null;
  }
};

export default VODRentingButton;
